import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import { de } from './de';
import { en } from './en';
import { es } from './es';
import { fr } from './fr';
import { it } from './it';
import { ja } from './ja';
import { pt } from './pt-br';

export const defaultNS = 'common';

export const resources = {
  'en-US': en,
  'de-DE': de,
  'es-ES': es,
  'pt-BR': pt,
  'it-IT': it,
  'fr-FR': fr,
  'ja-JP': ja,
};

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources,
    fallbackLng: {
      default: ['en-US'],
    },
    supportedLngs: [
      'en-US',
      'de-DE',
      'es-ES',
      'pt-BR',
      'it-IT',
      'fr-FR',
      'ja-JP',
    ],
    interpolation: {
      escapeValue: false,
    },
    defaultNS,
  });
